import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Spin } from 'antd'
import { Redirect } from 'react-router-dom'

import styles from './index.module.css'
import PageCard from './components/PageCard'
import { actionCreators } from './store'
import { actionCreators as homeActionCreators } from '../home/store'
import wechatBgArrow from '../../statics/wechat_container_arrow.gif'
import wechatLoadingImg from '../../statics/loading.gif'
import { getUrlVars, getOriginWithExplicitPort, isDevelopment, detectDevice } from '../../utils'
import { forceReloadTo } from '../../utils/hardNavigation'


class Login extends Component {
    constructor(props) {
        super(props)
        const environment = detectDevice();
        this.state = {
            environment: environment,
        }
        this.isFetchingLogin = false  // [2026-04-17 修复] React StrictMode 双重调用防抖
    }

    componentDidMount () {
        this.detectEnvironment()
        // 获取用户当前环境是否是移动端
        this.getIsMobile()
    }

    detectEnvironment() {
        if (this.state.environment === 'computer_enterprise_wechat' || this.state.environment === 'mobile_enterprise_wechat') {
            // 现在状态已更新，添加事件监听器
            window.addEventListener('wheel', this.handleWheel, { passive: false });
            this.handleDesktopQYwechatLoginStatus();
        } else if (this.state.environment === 'computer_browser') {
            this.handleScanLoginStatus();
        }
    }

    componentWillUnmount () {
        if (this.state.environment === 'computer_enterprise_wechat' || this.state.environment === 'mobile_enterprise_wechat') {
            // 组件将要卸载时移除滚轮事件监听
            window.removeEventListener('wheel', this.handleWheel, { passive: false });
        }
    }

    handleWheel = (event) => {
        if (event.ctrlKey) {
            console.log("禁止缩放");
            // 阻止默认的缩放行为
            event.preventDefault();
        }
    }

    handleDesktopQYwechatLoginStatus() {
        if (getUrlVars().code) {
            let company_route = '/account/jieen_qywx_scan_login'
            let what_company = sessionStorage.getItem('what_company')

            if (what_company === 'jietu') {
                company_route = '/account/jietu_qywx_scan_login'
            } else {
                company_route = '/account/jieen_qywx_scan_login'
            }

            // 判断如果是企业微信登录，则跳转，显示 loading 以及请求 authen_token
            this.props.handleIsLoginLoadingAction(true)

            const url = getOriginWithExplicitPort() + `/api${company_route}?code=${getUrlVars().code}&state=${getUrlVars().code}`
            // 发起一个GET请求到指定的URL
            fetch(url)
                .then(response => {
                    console.log("response = ", response);
                    // 首先检查响应的状态码是否表明请求成功
                    if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                    } else {
                        // 然后解析 JSON 格式的响应体
                        return response.json();
                    }
                })
                .then(data => {
                    // 处理解析后的数据
                    console.log(data);
                    let d = data.data
                    this.props.handleUserDataAction(d)
                    this.props.handleIsLoginLoadingAction(false)
                    this.props.handleHasLoginAction(true)
                    if (d.is_first_login) {
                        // 首次登录
                        this.props.handleIsShowUserResearch(true)
                    } else if (d.has_details === false) {
                        this.props.handleIsShowUserResearch(true)
                    }

                    // [2026-04-17] 使用 forceReloadTo 替代 history.push，确保 Home 组件正确初始化
                    forceReloadTo("#/home")
                })
                .catch(error => {
                    // 处理请求过程中发生的任何错误
                    console.error('登录报错:', error);
                    this.props.handleIsLoginLoadingAction(false)
                    forceReloadTo("#/")
                });
        } else {
            this.generateWeChatAuthUrl()
        }
    }

    generateWeChatAuthUrl () {
        let agent_id = ''
        let appid = ''
        let login_status = ''
        let what_company = sessionStorage.getItem('what_company')
        let corp = ''
        if (!what_company) {
            corp = getUrlVars().corp === 'jietu' ? 'jietu' : 'jieen'
        } else {
            corp = what_company
        }
        sessionStorage.setItem('what_company', corp)

        if (isDevelopment()) {
            agent_id = '1000097'        // [jieen开发] 可信域名: test.linkstone.chat (2026-04-17 修改, 旧值: 1000039)
            appid = 'wwdfc157b24bebba67'
            login_status = 'dev'
            corp='jieen'
            sessionStorage.setItem('what_company', corp)
        } else {
            if (corp === 'jietu') {
                agent_id = '1000010'
                appid = 'ww8a57b5cd8b30618a'
                login_status = 'pro'
            } else {
                agent_id = '1000040'
                appid = 'wwdfc157b24bebba67'
                login_status = 'pro'
            }
        }

        const baseUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize';
        const encodedRedirectUri = encodeURIComponent(getOriginWithExplicitPort());
        const scope = 'snsapi_userinfo';
        const state = 'test';

        let authUrl = `${baseUrl}?appid=${appid}&redirect_uri=${encodedRedirectUri}&response_type=code&scope=${scope}&state=${state}&agentid=${agent_id}#wechat_redirect`;
        console.log("authUrl = ", authUrl);
        window.location.href = authUrl;
    }

    handleScanLoginStatus() {
        // [2026-04-17 修复] React StrictMode 在开发环境下会双重调用 componentDidMount
        // 防止 code 被重复使用导致 400 错误（企业微信 code 只能用一次）
        if (this.isFetchingLogin) return
        this.isFetchingLogin = true

        let company_route = ''
        let what_company = sessionStorage.getItem('what_company')
        sessionStorage.removeItem('what_company')

        if (what_company === 'jietu') {
            company_route = '/account/jietu_qywx_scan_login'
        } else {
            company_route = '/account/jieen_qywx_scan_login'
        }

        if (getUrlVars().code) {
            // 判断如果是企业微信登录，则跳转，显示 loading 以及请求 authen_token
            this.props.handleIsLoginLoadingAction(true)

            const url = getOriginWithExplicitPort() + `/api${company_route}?code=${getUrlVars().code}&state=${getUrlVars().code}`
            // 发起一个GET请求到指定的URL
            fetch(url)
                .then(response => {
                    console.log("response = ", response);
                    // 首先检查响应的状态码是否表明请求成功
                    if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                    } else {
                        // 然后解析 JSON 格式的响应体
                        return response.json();
                    }
                })
                .then(data => {
                    // 处理解析后的数据
                    console.log(data);
                    let d = data.data
                    this.props.handleUserDataAction(d)
                    this.props.handleIsLoginLoadingAction(false)
                    this.props.handleHasLoginAction(true)
                    if (d.is_first_login) {
                        // 首次登录
                        this.props.handleIsShowUserResearch(true)
                    } else if (d.has_details === false) {
                        this.props.handleIsShowUserResearch(true)
                    }

                    // [2026-04-17] 使用 forceReloadTo 替代 history.push，确保 Home 组件正确初始化
                    forceReloadTo("#/home")
                })
                .catch(error => {
                    // 处理请求过程中发生的任何错误
                    console.error('登录报错:', error);
                    this.props.handleIsLoginLoadingAction(false)
                    forceReloadTo("#/")
                });
        }
    }
    getIsMobile () {
        if (detectDevice() === 'mobile_enterprise_wechat') {
            this.props.handleIsMobileAction(true)
        }
    }

    render () {
        if (this.state.environment === 'computer_browser' || this.state.environment === 'mobile_browser') {
            if (this.props.is_login_loading) {
                return (
                    <div className={styles.container_loading}>
                        <Spin tip="Loading..."></Spin>
                    </div>
                )
            }

            if (this.props.has_login) {
                return <Redirect to="/home" />
            }

            return (
                <div className={styles.container}>
                    <PageCard />
                </div>
            )
        } else if (this.state.environment === 'computer_enterprise_wechat' || this.state.environment === 'mobile_enterprise_wechat') {
            if (this.props.is_login_loading) {
                return (
                    <div className={`${styles.qywechat_container} ${this.props.is_mobile ? styles.mobile_qywechat_container : ''}`}>
                        <img src={wechatLoadingImg} className={styles.qywechat_loading} />
                    </div>
                )
            }

            if (this.props.has_login) {
                return <Redirect to="/home" />
            }

            return (
                // <div className={`${styles.wechat_container} ${styles.wechat_bg_img}`}>
                //     <img src={wechatBgArrow} className={styles.wechat_bg_arrow} alt="wechat" />
                // </div>
                <div className={`${styles.qywechat_container} ${this.props.is_mobile ? styles.mobile_qywechat_container : ''}`}>
                    <img src={wechatLoadingImg} className={styles.qywechat_loading} />
                </div>
            )
        } else {
            return (
                <div className={`${styles.mobile_container} ${styles.mobile_bg_img}`}></div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        has_login: state.get('login').get('has_login'),
        is_login_loading: state.get('login').get('is_login_loading'),
        is_mobile: state.get('home').get('is_mobile'),
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        handleIsLoginLoadingAction (status) {
            dispatch(actionCreators.isLoginLoadingAction(status))
        },
        handleUserDataAction (data) {
            dispatch(actionCreators.userDataAction(data))
        },
        handleHasLoginAction (status) {
            dispatch(actionCreators.hasLoginAction(status))
        },
        handleIsShowUserResearch (status) {
            dispatch(homeActionCreators.isShowUserResearchAction(status))
        },
        handleIsMobileAction (status) {
            dispatch(homeActionCreators.isMobileAction(status))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
